export const SANITY_PREVIEW_ACCESS_DENIED =
  'You must be logged in to access preview';

export const NOT_FOUND = 'Content not found';
